import React, { Component } from "react";
import { connect } from 'react-redux';
import { fetchOrden,editOrden } from '../../actions/ordenesActions';
import { fetchPublicaciones } from '../../actions/publicacionesActions';
import {fetchSellersFilter} from '../../actions/sellersActions'; 
import Modal from 'react-bootstrap/Modal';
import { toast } from "react-toastify";
import {DropDownArrow, customStyle}  from "../../template/CustomStyle";
import Select from 'react-select';
import Cleave from 'cleave.js/react';
import PropTypes from 'prop-types';

class Productos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            show: false,
            seller: { label: '', value: '' },
            modalData:{
                skuMarket:"",
                cantidad:"",
                tituloProducto:""
            }
        }
    }

    componentDidUpdate = prevProps => {
        if (this.didEdit) {
            this.props.fetchOrden(this.props.idOrden);
            this.setState({
                didEdit: false
            })
        }
    }

    removeProducto=(e)=>{
        e.preventDefault();
        this.props.orden.productos.splice(e.target.name, 1);
        this.forceUpdate();
    }

    inputProducto = async (e) => {

        if (e.target.name == "skuMarket") {
            this.setState(prevState => ({
                modalData:{...prevState.modalData,[e.target.name]:e.target.value}
            }))
            this.busquedaSkuMarket(e.target.value);
            await this.setDatosProducto();
        }                
        this.setState(prevState => ({ modalData: { ...prevState.modalData, [e.target.name]: e.target.value } }));
    }

    setDatosProducto=()=>{
        return new Promise(()=>{
            setTimeout(()=>{                
                let data = this.props.datosProductos.filter(e => e.titulo);
                if (data.length > 0) {
                    this.setState(prevState => ({
                        modalData: {
                            ...prevState.modalData,
                            "tituloProducto":this.props.datosProductos[0].titulo,
                            "marca": this.props.datosProductos[0].marca.descripcion,
                            "precioLista": this.props.datosProductos[0].precioLista,
                            "skuSeller": this.props.datosProductos[0].skuSeller,
                            "ean": this.props.datosProductos[0].ean,
                            "categoria":this.props.datosProductos[0].categoria.descripcion,
                            "imagenPrincipal":this.props.datosProductos[0].imagenes[0],
                            "idSeller":this.props.datosProductos[0].idSeller
                        }
                    }))
                }
            },1000)
        });
        
    }

    busquedaSkuMarket = (skuMarket) => {
        this.props.fetchPublicaciones({ "SkuMarket": skuMarket });                
    }

    agregarProducto= () => {        
        let valido = this.validarModalData();
        if(valido != "") {
            toast.error(valido);
        }
        this.setPropiedades();
        this.setState({ show: false });
    }

    setPropiedades=()=>{

        let length = this.props.orden.productos.length;
        let i = length;

        this.props.orden.productos.push({
            "skuMarket":"",
            "cantidad":"",
            "tituloProducto":""
        });

        this.props.orden.productos[i]=this.state.modalData;
    }


    validarModalData=()=>{
        let valido = "";
        
        if (this.props.tituloProducto.length <= 0) {
            valido="Producto no encontrado";
        }
        if(this.state.modalData.cantidad <= 0) {
            valido="Ingrese cantidad mayor a 0";
        }
        if (this.props.datosProductos[0] != undefined) {
            if(this.props.datosProductos[0].stock <= 0) {
                valido="El producto no cuenta con stock suficiente";
            }
        }
        return valido;
    }

    handleClose = (e) => {
        if (e != null) e.preventDefault();
        this.setState({ show: false });
    }

    openModalAgregar=(e)=>{        
        e.preventDefault();    
        this.setState({
            show: true,
            modalData:{
                skuMarket:"",
                cantidad:""
            }
        })
    }

    selectSearchHandler = (options) => {
        let orden = this.props.orden;
        orden["idSeller"] = options.value;
        orden["sellerSelect"] = options;
        this.props.editOrden(orden);
    }

    onSelectSearchInputSellers = (descripcion) => { 
        this.props.fetchSellersFilter({descripcion});
    }

    enlace = (url) => {
        window.open(url, "_blank");
    }
  

    render() {

        let renderEdit=null;
        let renderNew=null;

        if (!this.props.newOrden) {            
            
            renderEdit=this.props.orden.productos.map((item) => {
                return (
                    <button key={item.titulo} style={{ border: "none", background: "none" }} className="list-group-item hover-background-color" onClick={() => { this.enlace(item.urlFichaWeb) }} data-toggle="tooltip" title="Click para visualizar la publicacion"> 
                        <div className="row" >
                            <div className="col-md-1 col-lg-1 col-1">
                                <img src={item.imagenPrincipal != "" ? item.imagenPrincipal : "https://via.placeholder.com/80"} alt="user-img" className="mw-40px img-responsive"></img>
                            </div>
                            <div className="col-md-11 col-lg-11">
                                <h6 className="box-title m-b-5 font-weight-bold"> {item.titulo}</h6>
                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 align-self-center">
                                            <small className="font-weight-bold" style={{color:"#404040"}}> {item.subfamilia.descripcion} </small><br />
                                            <small className="font-weight-bold" style={{color:"#404040"}}> {item.marca.descripcion} </small><br />
            
                                        </div>
                                        <div className="col-md-4 col-lg-4">
                                            <p className="font-weight-bold m-b-0" style={{color:"#404040"}}><small className="applyFont">SKU MARKET: </small> {item.skuMarket}</p>
            
                                            <p className="font-weight-bold m-b-0" style={{color:"#404040"}}><small className="applyFont">SKU SELLER: </small> {item.sellerSku}</p>
            
                                            <p className="font-weight-bold m-b-0" style={{color:"#404040"}}><small className="applyFont">EAN</small> {item.ean}</p>
            
                                        </div>
            
                                        <div className="col-md-4 col-lg-4 align-self-center div-center">
                                            <p className="font-weight-bold m-b-0">{item.cantidad} Unidades x $ {item.precioUnitario}</p>
                                        </div>
                                    </div>
            
                                
                            </div>
                        </div>
            
                    </button>
                )
            })
            
        }
        if (this.props.newOrden) {

            renderNew = this.props.orden.productos.map((item, index) => {
                
                return (
                    <>
                    <div className="form-group col-lg-12">
                                <p style={{ fontWeight: "600", paddingRight: "1em" }}>Producto {index + 1}</p>
                                <button 
                                    onClick={this.removeProducto} 
                                    style={{ marginRight: "1em" }} 
                                    name={index} 
                                    className="btn btn-sm btn-light waves-effect waves-light"
                                >
                                    <i className="fas fa-minus"/>
                                </button>
                            </div>
                        <div className="list-group-item hover-background-color">
                            <div className="row">

                                <button type="button" style={{ border: "none", background: "none" }} className="col-md-1 col-lg-1 col-1" onClick={() => this.enlace(item.urlFichaWeb)}>
                                    <img 
                                        src={item.imagenPrincipal != undefined ? item.imagenPrincipal : "https://via.placeholder.com/80"}
                                        alt="user-img" 
                                        className="mw-40px img-responsive"
                                    ></img>
                                </button>

                                <div className="col-md-11 col-lg-11">

                                    <h6 className="box-title m-b-5 font-weight-bold">{item.tituloProducto}</h6>
                                    <br/>

                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 align-self-center">
                                            <small 
                                                className="font-weight-bold" 
                                                style={{ color: "#404040" }}
                                            > 
                                                {item.categoria} 
                                            </small>
                                            <br/>
                                            <small 
                                                className="font-weight-bold" 
                                                style={{ color: "#404040" }}
                                            > 
                                                {item.marca} 
                                            </small>
                                            <br/>
                                        </div>
                                        <div className="col-md-4 col-lg-4">
                                            <p className="font-weight-bold m-b-0" style={{ color: "#404040" }}><small className="applyFont">SKU MARKET: </small> {item.skuMarket}</p>

                                            <p className="font-weight-bold m-b-0" style={{ color: "#404040" }}><small className="applyFont">SKU SELLER: </small> {item.skuSeller}</p>

                                            <p className="font-weight-bold m-b-0" style={{ color: "#404040" }}><small className="applyFont">EAN</small> {item.ean}</p>

                                        </div>

                                        <div className="col-md-4 col-lg-4 align-self-center div-center">
                                            <p className="font-weight-bold m-b-0">{item.cantidad} Unidades x $ {item.precioLista}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );
            })
        }
        
        let selectSellers = null;
        let renderHtml = null;
        let buttonAgregar = null;

        let listaSeller=[];
        this.props.sellers.forEach((item, index) => {            
            listaSeller.push({ label: item.label, value: item.value })
        })

        if (!this.props.newOrden) {
            renderHtml = renderEdit;
        } else if (this.props.tipoUsuario == 2 && this.props.newOrden) {
            renderHtml = renderNew;
            selectSellers = <div className="col-lg-6">
                <label htmlFor="sellerProductos">Seller</label>
                <Select
                    id="sellerProductos"
                    name="seller"
                    value={this.props.orden.sellerSelect}
                    options={listaSeller}
                    onChange={this.selectSearchHandler}
                    onInputChange={this.onSelectSearchInputSellers}
                    styles={customStyle}
                    components={{ DropdownIndicator: () => DropDownArrow }}
                />
            </div>
            buttonAgregar = <button onClick={this.openModalAgregar} className="btn background-rojo-megatone btn-sm ">Agregar</button>
        } else {
            renderHtml = renderNew;
            buttonAgregar = <button onClick={this.openModalAgregar} className="btn background-rojo-megatone btn-sm ">Agregar</button>
        }

        let mostrarTituloSkuMarket = null;
        mostrarTituloSkuMarket = <p style={{ fontWeight: "600" }}>{this.props.tituloProducto?.length > 0 ? this.props.tituloProducto[0].titulo : (this.state.modalData.skuMarket != "" && <span style={{ color: "red" }}>Producto no encontrado</span>)}</p>
        if (this.props.datosProductos != undefined) {
            if (this.props.datosProductos[0]?.stock == 0) mostrarTituloSkuMarket = <p style={{ fontWeight: "600", color: "red" }}>Producto sin stock</p>
        }


        let modalCreate=<Modal show={this.state.show} onHide={this.handleClose}>
        <Modal.Body>                
                <div className="form-group col-lg-12">
                    <label htmlFor="skuMarketProductos"> Sku Market </label>
                    <input 
                        id="skuMarketProductos"
                        type="text" 
                        className="form-control" 
                        value={this.state.modalData.skuMarket} 
                        name={"skuMarket"} 
                        onChange={this.inputProducto} 
                    />
                    {mostrarTituloSkuMarket}
                </div>
                <div className="form-group col-lg-12">
                    <label htmlFor="cantidadProductos">Cantidad </label>
                    <Cleave 
                        id="cantidadProductos"
                        className="form-control" 
                        name="cantidad" 
                        value={this.state.modalData.cantidad}
                        options={{ blocks: [2], numericOnly: true }}
                        onChange={this.inputProducto} 
                    />
                </div>
        </Modal.Body>
        <Modal.Footer>
            
            <button className="btn background-rojo-megatone btn-sm" onClick={this.agregarProducto}>
                Agregar
            </button>
            <button className="btn btn-grey btn-sm" onClick={this.handleClose}>
                Cerrar
            </button>
        </Modal.Footer>
        </Modal>


        return (
            <div className="tab-pane p-20 active " name="datos" id="home2" role="tabpanel">
                {selectSellers}
                <br></br>
                {buttonAgregar}
                {renderHtml}
                {modalCreate}
            </div>
        );
    }
}
Productos.propTypes = {
    // Redux props
    orden: PropTypes.shape({
        productos: PropTypes.array,
        idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        sellerSelect: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    idOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    datosProductos: PropTypes.arrayOf(PropTypes.shape({
        titulo: PropTypes.string,
        marca: PropTypes.shape({
            descripcion: PropTypes.string,
        }),
        precioLista: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        skuSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        ean: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        categoria: PropTypes.shape({
            descripcion: PropTypes.string,
        }),
        imagenes: PropTypes.array,
        idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        stock: PropTypes.number,
    })),
    tituloProducto: PropTypes.arrayOf(PropTypes.shape({
        titulo: PropTypes.string,
    })),
    sellers: PropTypes.array,
    tipoUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    newOrden: PropTypes.bool,
    // Actions props
    editOrden: PropTypes.func,
    fetchOrden: PropTypes.func,
    fetchPublicaciones: PropTypes.func,
    fetchSellersFilter: PropTypes.func,
}

const mapStateToProps = state => ({
    sellers: state.sellers.filteredSellers,
    datosProductos:state.publicaciones.publicaciones.elementos,
    tituloProducto:state.publicaciones.publicaciones.elementos,
    orden: state.ordenes.orden,
    tipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps, { 
    fetchOrden,
    editOrden,
    fetchPublicaciones,
    fetchSellersFilter
}) (Productos);